import styled from 'styled-components'

export const Button = styled.button<any>`
  background-color: #34bebd;
  margin: 10px;
  padding: 20px 0;
  cursor: pointer;
  border-radius: 10px;
  border: 1px solid #34bebd;
  width: 150px;
  height: 60px;
  letter-spacing: 0.23px;
  color: #fff;
  font:
    bold 15px Lato,
    sans-serif;
  outline: none;

  &:disabled {
    background: #f2f2f2;
    border-color: #f2f2f2;
    color: #082842;
    pointer-events: none;
  }
`

export const AlternateButton = styled(Button)`
  background: none;
  border-color: #082842;
  color: #082842;
`
